/*jshint bitwise: false*/

export const name = 'templateDetailsDirective';
import repetitionCounterWorker from "worker-loader!../db_parser_factory/db-repetition-counter-worker.js";

export default function templateDetailsDirective(templatesService, presetsService, $stateParams, $log, $scope, errorDialogOpen, chipsService,
                                                 $mdDialog, dataCacheViewFactory, dbParserFactory, $q, impositionTemplatesService, $translate, pusherChannel, rnPusher,
                                                 $state, stateKeeperService, $rootScope, analyticsFactory, $gzGo, imageLoadProgressService, assetsLibService, $window, breadcrumbsService) {
    //noinspection BadExpressionStatementJS
    'ngInject';
    let vm = this;
    let worker;
    let workers = [];
    vm.templateId = $stateParams.composerTemplateId;
    vm.template = $stateParams.compositionTemplate;
    vm.templatesService = templatesService;
    vm.filesNumberLimit = 10;
    vm.uploadLimitValidationMsg = false;
    vm.selectedAssetLibs = [];
    vm.selectedAssetLibsToDisplay = '';
    vm.dataBeingUpdated = true;
    vm.headers = null;
    vm.editingForm = null;
    vm.imagePreviewManager = dataCacheViewFactory.createViewCache(fetchDataCallback, 0.4, 0.4);
    vm.dataStorageId = null;
    vm.repetitionColIndex = null;
    vm.dataManager = dataCacheViewFactory.createDataManager(vm.imagePreviewManager, getTemplateDb, setDataBeingUpdatedCallback, null, null, null, skipUnskipFirstRowCallback);
    vm.tagsObjects = null;
    vm.originalTemplateInfo = null;
    vm.originalPresetInfo = null;
    vm.isDefaultDataLoaded = false;
    vm.hideCurrentView = false;
    vm.previewErrorMsg = undefined;
    vm.numOfSheets = 0;
    vm.recordsInImposition = 1;
    vm.sheetsInImposition = 1;
    vm.isDataFileLimitExceeded = false;
    vm.dataFileStorageId = null;
    vm.dataFileStorageIds = [];
    vm.dbProgressDetails = [];
    vm.repetitionsInfoText = null;
    vm.selectedPreset = null;
    vm.dataFromStorageFile = {
        exists: $stateParams.dataFileName !== undefined,
        dataFileName: decodeURIComponent($stateParams.dataFileName),
        dataFileStorageId: $stateParams.dataFileStorageId
    };
    vm.csvFileLoader = new CsvFileLoader();
    vm.compose = compose;
    vm.applyChanges = applyChanges;
    vm.openImpositionEdit = openImpositionEdit;
    vm.onViewAllData = onViewAllData;
    vm.openInfoDialog = openInfoDialog;
    vm.clearAssetsLibsSelection = clearAssetsLibsSelection;
    vm.shouldShowImposedPreview = shouldShowImposedPreview;
    vm.openCounterWizard = openCounterWizard;
    vm.openDbListDialog = openDbListDialog;

    vm.channelName = null;

    let fileSizeEditLimit = 30000000;
    let recordsLimit = 100;
    let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
    vm.warningIcon = iconsRequire("./warning.svg");
    vm.infoIcon = iconsRequire("./Info.svg");
    vm.linkedFolderIcon = iconsRequire("./linked-folder.svg");

    let requireMissingImage = require.context('@printos/imposer-ui/src/components/templates/images', false, /\.svg/);
    let missingImageWithText = requireMissingImage("./placeholder-greyed-missing-image-text-composer.svg");

    if ($state.current.name !== 'templates.templatedetails' && $state.current.name !== 'templates.templatedetailswithdata') {
        vm.hideCurrentView = true;
    } else {
        vm.hideCurrentView = false;
    }

    if ($state.current.name === 'templates.templatedetailswithdata') {
        if ($window.Intercom) {
            $window.Intercom('trackEvent', 'Composer - Open from InDesign or Illustrator');
        }
    }

    function registerEvents() {
        let defer = $q.defer();
        pusherChannel.getChannelName().then(channelName => {
            vm.channelName = channelName;
            let promises = [];
            promises.push(rnPusher.bind(channelName, "HPD_ENTRY_PRESET_UNLINK", onPresetUnlink));
            promises.push(rnPusher.bind(channelName, "HPD_ENTRY_IMPOSITION_UNLINK", onImpositionUnlink));
            promises.push(rnPusher.bind(channelName, "PRESET_LIST_ENTRY_ADDED", onPresetEntryAdded));
            promises.push(rnPusher.bind(channelName, "PRESET_LIST_ENTRY_CHANGED", onPresetEntryChanged));

            $q.all(promises).then(() => {
                defer.resolve();
            });
        });

        return defer.promise;
    }

    (function () {
        if (vm.template !== null && vm.template !== undefined) {
            activate();
        } else {
            templatesService.getTemplate(vm.templateId).then(template => {
                vm.template = template;
                vm.templateId = template.templateId;
                activate();
            });
        }
    })();

    function activate() {
        let functionName = 'detailedTemplateController.activate';
        $log.info(angular.toJson({action: 'function called', functionName: functionName, templateId: vm.templateId}));

        vm.impositionSelection = new impositionTemplatesService.ImpositionSelection(isCustomDistributionRequired());
        registerEvents();
        breadcrumbsService.isBreadcrumbsFeatureEnabled().then(isNewBreadcrumbsActivated => {
            if (!isNewBreadcrumbsActivated) {
                vm.breadcrumbs = [
                    {
                        state: 'templates',
                        titleKey: 'imposer.composer-main.Template_Imposition_Templates'
                    },
                    {
                        state: 'templates.templatedetailswithdata',
                        titleKey: 'imposer.composer-main.Template_Imposition_Template'
                    }
                ];
            }
        });

        vm.template.fieldsAssetsPathsInfo = JSON.parse(vm.template.fieldsAssetsPathsInfo);
        vm.dataManager.setNewData(null);
        saveTemplateRestore(vm.template);
        vm.dataManager.setNumberOfPages(vm.template.numberOfPages);

        // need to add time stamp as the cache doesnt work always with cross domain call to S3
        vm.imagePreviewManager.setDefaultThumbnailUrl(vm.template.thumbnailUrl);

        vm.impositionSelection.setDefaultImpositionTemplate(vm.template.impositionDefaultExist, vm.template.impositionDefaultId,
            vm.template.overrideImpositionId, vm.template.isDuplexImpJlyt);
        handleImpositionPreviewState();
        let isDefaultData = !vm.template.predefined;

        let promises = [];
        promises.push(vm.dataManager.updateDataFromService(vm.template.defaultDbStorageId, vm.template.dataFileUrl, isDefaultData));
        promises.push(presetsService.getPresetsByPage(1, 1000));
        $q.all(promises).then(function () {
            promises[0].then(() => {
                if (vm.dataFromStorageFile.exists) {
                    vm.csvFileLoader.loadDataFromPageUrl().then(function () {
                        vm.isDefaultDataLoaded = true;
                    }, function () {
                        console.error('loadDataFromPageUrl failed');
                    });
                } else if (vm.template.dataFileUrl !== null && vm.template.dataFileUrl !== undefined && vm.template.dataFileUrl !== '') {
                    //vm.csvFileLoader.fileName = decodeURI(vm.template.dataFileUrl.substring(vm.template.dataFileUrl.lastIndexOf('/')+1));
                    $translate.onReady(function () {
                        vm.csvFileLoader.fileName = $translate.instant(vm.template.translatedDataFileName);
                    });
                    vm.isDefaultDataLoaded = true;
                } else {
                    vm.isDefaultDataLoaded = true;
                }
                if (vm.repetitionColIndex !== null && vm.dataManager.data.length > 0) {
                    vm.repetitionsInfoText = $translate.instant('imposer.composer-main.Total_of_rows', [vm.dataManager.data.length, vm.dataManager.repetitions]);
                    if (!isNaN(vm.dataManager.data[0][vm.repetitionColIndex]) && Number.isInteger(+vm.dataManager.data[0][vm.repetitionColIndex]) && +(vm.dataManager.data[0][vm.repetitionColIndex] >= 0)) {
                        vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repeat_by_column_enabled', [vm.dataManager.data[0][vm.repetitionColIndex]]);
                    } else {
                        vm.dataManager.isRepetitionValuesLegal = false;
                        vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repetition_values_not_valid');
                    }
                } else if (vm.template.fixedNumberOfRows > 1) {
                    vm.repetitionsInfoText = $translate.instant('imposer.composer-main.Total_of_rows', [vm.dataManager.data.length, Math.ceil(vm.dataManager.data.length / vm.template.fixedNumberOfRows)]);
                }
            }, status => {
                errorDialogOpen.openErrorDialog(status);
            });

            promises[1].then(response => {
                vm.presets = response.listOfElements.map(curr => {
                    if (curr.predefined) {
                        $translate.onReady(() => {
                            curr.name = $translate.instant('imposer.composer-main.' + curr.name);
                        });
                    }
                    if (curr.sameNameIndex > 0) {
                        curr.name = curr.name + '-' + curr.sameNameIndex;
                    }
                    return curr;
                });
                vm.selectedPreset = vm.presets.filter(preset => preset.id === vm.template.presetId)[0];
                vm.originalPresetInfo = angular.copy(vm.selectedPreset);
                if (vm.template.lastPresetUpdateTime && vm.selectedPreset.lastUpdateTime &&
                    vm.template.lastPresetUpdateTime < vm.selectedPreset.lastUpdateTime &&
                    ((vm.template.overrideImpositionId && vm.selectedPreset.impositionId > 0 && vm.template.overrideImpositionId !== vm.selectedPreset.impositionId) ||
                        (vm.selectedPreset.impositionId === -1 && vm.template.overrideImpositionId !== null && vm.selectedPreset.impositionId !== vm.template.overrideImpositionId) ||
                        vm.template.engineMode !== vm.selectedPreset.preferredMode)) {
                    vm.template.presetChanged = true;
                    vm.restorePresetTooltip = $translate.instant('imposer.composer-main.template_preset_change_tooltip');
                }
            }, error => {
                $log.error(angular.toJson({
                    action: 'Failed to fetch presets',
                    error: error,
                    functionName: functionName
                }));
            });

        }, function (status) {
            errorDialogOpen.openErrorDialog(status);
        });

        if (vm.template.predefined === true) {
            $scope.$watch('$viewContentLoaded', function () {

            });
        }

        if (vm.dataFromStorageFile.exists && vm.template.templateCreationStatus === 'Warning') {
            templatesService.viewErrorDetails(undefined, vm.template);
        }

        $translate.onReady(() => {
            vm.restorePresetTooltip = $translate.instant('imposer.composer-main.template_preset_restore_preset_tooltip');
        });
    }


    vm.applyPresetSettings = function (selectedPreset, isPresetChange = true, isCustomPreset = false, isPresetRestore = false) {
        let presetToApply = null;

        if (!isPresetChange) {
            vm.template.presetChanged = true;
            vm.restorePresetTooltip = $translate.instant('imposer.composer-main.template_preset_change_tooltip');
            return;
        }

        if (selectedPreset) {
            presetToApply = selectedPreset;
            vm.selectedPreset = selectedPreset;
        } else {
            vm.selectedPreset = vm.presets.filter(preset => preset.id === vm.template.presetId)[0];
            presetToApply = vm.selectedPreset;
        }

        if (vm.template.potentialMode === 'Both' && vm.template.engineMode !== presetToApply.preferredMode) {
            if (vm.template.engineMode === 'Rich' && presetToApply.preferredMode === 'Fast') {
                vm.template.engineMode = presetToApply.preferredMode;
                //Restore custom distribution impositions
                vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired()).then(() => {
                    applyImpositionFromPreset(presetToApply, isPresetChange, isCustomPreset);
                });
            } else {
                applyImpositionFromPreset(presetToApply, isPresetChange, isCustomPreset);
                vm.impositionSelection.removeCustomDistributionImpositions();
                vm.template.engineMode = presetToApply.preferredMode;
            }
        } else {
            applyImpositionFromPreset(presetToApply, isPresetChange, isCustomPreset);
        }

        if (vm.editingForm && vm.editingForm.engineMode && presetToApply.preferredMode !== vm.template.engineMode) {
            if (isPresetChange) {
                vm.editingForm.engineMode.$setDirty(true);
            } else {
                vm.template.presetChanged = true;
            }
        }

        handlePresetSkipFirstRow(presetToApply);

        // if the preset change came from compose dialog
        if (!isCustomPreset) {
            vm.template.customSettings = false;

            //if the function called due to preset change
            if (isPresetChange) {
                vm.editingForm.$setDirty(true);
                vm.template.presetChanged = false;
            }
        }

        if (vm.originalPresetInfo.id === presetToApply.id &&
            (!isPresetRestore || (vm.originalTemplateInfo.overrideImpositionId === vm.template.overrideImpositionId && vm.originalTemplateInfo.engineMode === vm.template.engineMode))) { //if we are back to the original preset
            if (vm.editingForm.engineMode) {
                vm.editingForm.engineMode.$setPristine();
            }
            vm.editingForm.preset.$setPristine();
            vm.editingForm.impositionTemplate.$setPristine();
            vm.template.customSettings = false;
            if (vm.editingForm.$$controls.filter(control => control.$dirty).length === 0) {
                vm.editingForm.$setPristine();
            }
        }
    };

    function applyImpositionFromPreset(presetToApply, isPresetChange, isCustomPreset) {
        let selectedImposition = null;
        //in case of no imposition
        if (presetToApply.applyImposition === false && (vm.template.overrideImpositionId != null || vm.template.impositionDefaultId != null)) {
            selectedImposition = vm.impositionSelection.impositionTemplatesSelection.filter(imposition => imposition.isNoImpositionEntry)[0];
            vm.template.overrideImpositionId = selectedImposition.templateId;
            vm.impositionSelection.selectedImpositionTemplate = selectedImposition;
            if (isPresetChange) {
                vm.editingForm.impositionTemplate.$setDirty(true);
            }
            if (isCustomPreset) {
                vm.template.customSettings = true;
            }
            //in case of default imposition
        } else if (presetToApply.impositionId === -1 && vm.template.impositionDefaultId != null &&
            (!isCustomPreset || vm.template.impositionDefaultId !== vm.impositionSelection.selectedImpositionTemplate.templateId)) {
            //select default imposition
            selectedImposition = vm.impositionSelection.impositionTemplatesSelection.find(imposition => imposition.templateId === vm.template.impositionDefaultId);

            if (selectedImposition) {
                vm.template.overrideImpositionId = selectedImposition.templateId;
                vm.impositionSelection.selectedImpositionTemplate = selectedImposition;
                if (isPresetChange) {
                    vm.editingForm.impositionTemplate.$setDirty(true);
                }
                if (isCustomPreset) {
                    vm.template.customSettings = true;
                }
                //in case of override imposition
            }
        } else if (presetToApply.impositionId > 0 && ((vm.template.overrideImpositionId && vm.template.overrideImpositionId !== presetToApply.impositionId) ||
            (vm.template.overrideImpositionId == null || vm.template.impositionDefaultId == null))) {
            selectedImposition = vm.impositionSelection.impositionTemplatesSelection.find(imposition => imposition.templateId === presetToApply.impositionId);

            if (selectedImposition) {
                vm.template.overrideImpositionId = selectedImposition.templateId;
                vm.impositionSelection.selectedImpositionTemplate = selectedImposition;
                if (isPresetChange) {
                    vm.editingForm.impositionTemplate.$setDirty(true);
                }
                if (isCustomPreset) {
                    vm.template.customSettings = true;
                }
            }
        }
    }

    function handlePresetSkipFirstRow(preset) {
        switch (preset.skipRows) {
            case -1: // Dont skip first row
                if (vm.dataManager.skipFirstRow) {
                    vm.dataManager.skipFirstRow = false;
                    vm.dataManager.onSkipFirstRecord();
                }
                break;
            case 0: // Skip automatically
                if (vm.dataManager.shouldSkipFirstRow === false && vm.dataManager.skipFirstRow === true && vm.dataManager.data.length > 1) {
                    vm.dataManager.skipFirstRow = false;
                    vm.dataManager.onSkipFirstRecord();
                } else if (vm.dataManager.shouldSkipFirstRow === true && vm.dataManager.skipFirstRow === false && vm.dataManager.data.length > 1) {
                    vm.dataManager.skipFirstRow = true;
                    vm.dataManager.onSkipFirstRecord();
                }
                break;
            case 1: // Skip first row
                if (vm.dataManager.skipFirstRow === false && vm.dataManager.data.length > 1) {
                    vm.dataManager.skipFirstRow = true;
                    vm.dataManager.onSkipFirstRecord();
                }
                break;
        }
    }

    function getDataLength() {
        return vm.dataManager.data ? vm.dataManager.data.length : 1;
    }

    function updateJobProperties() {
        let jobProperties = {
            recordsInImposition: vm.recordsInImposition,
            sheetsInImposition: vm.sheetsInImposition
        };
        templatesService.updateJobProperties(vm.templateId, jobProperties);
    }

    function shouldShowImposedPreview() {
        if (vm.isImpositionExist) {
            if (vm.template.richTemplate !== undefined && vm.template.richTemplate !== null && vm.template.richTemplate === true) { // temporary due to lack of Engine Implementation
                return false;
            } else {
                $('.composer-detailed-template .preview-container').css('height', 'calc(100% - 200px)');
                return true;
            }
        } else {
            return false;
        }
    }

    function handleImpositionPreviewState() {
        vm.isImpositionExist = ((vm.template.overrideImpositionId !== null || vm.template.impositionDefaultId !== null || vm.template.impositionDefaultExist) && vm.template.overrideImpositionId !== -1);
    }

    vm.onPreviewWithImposition = function () {
        let assetsLibsStorageIds = vm.selectedAssetLibs.map(curr => curr.storageId);
        if (vm.dataFromStorageFile.exists) {
            switchToState('templates.templatedetailswithdata.imposedpreview', {
                composerTemplateId: vm.template.templateId,
                isDuplex: vm.impositionSelection.selectedImpositionTemplate.isDuplex,
                data: vm.dataManager.data,
                templateName: vm.template.templateName,
                dataFileName: encodeURIComponent(vm.dataFromStorageFile.dataFileName),
                dataFileStorageId: vm.dataFromStorageFile.dataFileStorageId,
                assetsLibrariesStorageIds: assetsLibsStorageIds
            });
        } else {
            switchToState('templates.templatedetails.imposedpreview', {
                composerTemplateId: vm.template.templateId,
                isDuplex: vm.impositionSelection.selectedImpositionTemplate.isDuplex,
                data: vm.dataManager.data,
                templateName: vm.template.templateName,
                dataFileName: encodeURIComponent(vm.csvFileLoader.fileName),
                assetsLibrariesStorageIds: assetsLibsStorageIds
            });
        }
    };

    function openInfoDialog($event) {

        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: false,
            template: require('../../assets-management/assets-info-dialog/assetsInfoDialog.html'),
            controller: 'assetsInfoDialogController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {}
        }).then(function (newPreset) {

        });
    }

    vm.onPagePreviewClick = function () {
        let assetsLibsStorageIds = vm.selectedAssetLibs.map(curr => curr.storageId);
        if (vm.dataFromStorageFile.exists) {
            switchToState('templates.templatedetailswithdata.pagepreview', {
                composerTemplateId: vm.template.templateId,
                data: vm.dataManager.data,
                templateName: vm.template.templateName,
                dataFileName: encodeURIComponent(vm.dataFromStorageFile.dataFileName),
                totalPages: vm.template.numberOfPages,
                recordNumber: vm.dataManager.selectedRecord,
                pageNumber: vm.dataManager.selectedPage,
                headers: vm.headers,
                dataFileStorageId: vm.dataFromStorageFile.dataFileStorageId,
                assetsLibrariesStorageIds: assetsLibsStorageIds
            });
        } else {
            switchToState('templates.templatedetails.pagepreview', {
                composerTemplateId: vm.template.templateId,
                data: vm.dataManager.data,
                templateName: vm.template.templateName,
                dataFileName: encodeURIComponent(vm.csvFileLoader.fileName),
                totalPages: vm.template.numberOfPages,
                recordNumber: vm.dataManager.selectedRecord,
                pageNumber: vm.dataManager.selectedPage,
                headers: vm.headers,
                dataFileStorageId: null,
                assetsLibrariesStorageIds: assetsLibsStorageIds
            });
        }
    };

    vm.dataChange = function (dataHeader, newVal, oldVal) {
        if (vm.template.repetitionColumn === dataHeader && vm.repetitionColIndex !== null) {
            let repetitions = vm.dataManager.repetitions === 0 && !isNaN(oldVal) && Number.isInteger(+oldVal) ? +oldVal : vm.dataManager.repetitions;
            let repetitionValue = vm.dataManager.data[vm.dataManager.selectedRecord - 1][vm.repetitionColIndex];
            if (isNaN(repetitionValue) || !Number.isInteger(+repetitionValue) || repetitionValue < 0) {
                vm.dataManager.isRepetitionValuesLegal = false;
                vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repetition_values_not_valid');
                if (!isNaN(oldVal) && Number.isInteger(+oldVal)) {
                    repetitions -= +oldVal;
                }
            } else {
                if (isNaN(oldVal) || !Number.isInteger(+oldVal) || oldVal === '') {
                    if (dbParserFactory.countRepetitions(vm.repetitionColIndex, vm.dataManager.data).valid) {
                        vm.dataManager.isRepetitionValuesLegal = true;
                    }
                }
                if (isNaN(oldVal) || !Number.isInteger(+oldVal)) {
                    oldVal = '0';
                }
                repetitions = repetitions - (+oldVal) + (+newVal);
                vm.repetitionsInfoText = $translate.instant('imposer.composer-main.Total_of_rows', [vm.dataManager.data.length, repetitions]);
                vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repeat_by_column_enabled', [vm.dataManager.data[vm.dataManager.selectedRecord - 1][vm.repetitionColIndex]]);
                vm.dataManager.dataChange();
            }

            vm.dataManager.repetitions = repetitions;
        } else {
            vm.dataManager.dataChange();
        }
    };

    function skipUnskipFirstRowCallback() {
        if (vm.repetitionColIndex !== null && vm.dataManager.data.length > 0) {
            vm.repetitionsInfoText = $translate.instant('imposer.composer-main.Total_of_rows', [vm.dataManager.data.length, vm.dataManager.repetitions]);
            vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repeat_by_column_enabled', [vm.dataManager.data[vm.dataManager.selectedRecord - 1][vm.repetitionColIndex]]);
        }
    }

    vm.openAssetLibrarySelectionDialog = function ($event) {
        let functionName = 'TemplateListController.openUploadDialog';
        $log.info(angular.toJson({action: 'function called', functionName: functionName}));
        let fileSizeLimit = 10737418240; //10GB

        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: true,
            template: require('../../assets-management/upload-assets-libraries-dialog/asset-lib-upload-dialog.html'),
            controller: 'assetLibUploadDialogController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {
                title: 'imposer.composer-main.assets_management_select_upload',
                fileType: '.zip',
                fileTypeDisplay: 'ZIP',
                uploadMethod: assetsLibService.uploadFile,
                mimeType: null,
                fileSizeLimit: fileSizeLimit,
                analyticsUploadSuccess: () => {
                },
                analyticsUploadFail: () => {
                },
                deleteEntity: deleteCanceledAssetLib,
                assetLibSelectedCallback: assetLibSelectedCallback
            }
        }).then(function (assetLib) {
            $log.info(angular.toJson({
                action: 'dialog closed successfully',
                functionName: functionName,
                assetLib: assetLib
            }));
        });

        $log.info(angular.toJson({action: 'function return', functionName: functionName}));
    };

    function deleteCanceledAssetLib(assetLibUUID) {
        assetsLibService.deleteAssetLibraries([assetLibUUID]);
    }

    function assetLibSelectedCallback(selectedAssetLibs) {
        vm.isAssetsLibrarySelection = true;
        vm.selectedAssetLibs = selectedAssetLibs;
        vm.selectedAssetLibsToDisplay = '';
        selectedAssetLibs.forEach(function (assetLib) {
            if (assetLib.constant === false) {
                assetLib.name = assetLib.name.substring(0, assetLib.name.length - 37);
            }
            vm.selectedAssetLibsToDisplay += assetLib.name + ", ";
        });
        vm.selectedAssetLibsToDisplay = vm.selectedAssetLibsToDisplay.substring(0, vm.selectedAssetLibsToDisplay.length - 2);
        vm.dataManager.disableDataControls = true;

        vm.dataManager.resetPreview();
    }

    function clearAssetsLibsSelection($event) {
        let functionName = 'clearAssetLibsSelection';
        $log.info(angular.toJson({functionName: functionName}));

        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: true,
            template: require('./../../assets-management/discard-assets-libraries-selection-dialog/discard-assets-libraries-selection.html'),
            controller: 'discardAssetsLibrariesSelectionController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {}
        }).then(function () {
            vm.isAssetsLibrarySelection = false;
            vm.selectedAssetLibs = [];
            vm.selectedAssetLibsToDisplay = '';
            vm.dataManager.resetPreview();
        });
    }


    function setDataBeingUpdatedCallback(dataBeingUpdated) {
        vm.dataBeingUpdated = dataBeingUpdated;
    }

    function getTemplateDb(dataStorageId, url) {
        let defer = $q.defer();

        if (dataStorageId !== undefined) {
            templatesService.getTemplateDb(dataStorageId).then(success, failure.bind(this));
        } else if (url !== undefined) {
            templatesService.getTemplateDbFromURL(url).then(success, failure.bind(this));
            vm.csvFileLoader.fileName = url.substring(url.lastIndexOf('/') + 1);
        }

        function success(data) {
            let resolvedData = {
                data: data,
                parseDataCallback: parseDataFromFile
            };
            defer.resolve(resolvedData);
        }

        function failure(status) {
            errorDialogOpen.openErrorDialog(status);
            defer.reject(status);
        }

        return defer.promise;
    }

    function fetchDataCallback(cacheCellRequests) {
        let defer = $q.defer();

        let assetsLibsStorageIds = vm.selectedAssetLibs.map(curr => curr.storageId);

        templatesService.fetchCacheWithEmbeddedDataRequest(vm.template.templateId, vm.headers, cacheCellRequests, assetsLibsStorageIds).then(
            function (imageUrls) {
                for (let iCell = 0; iCell < imageUrls.length; iCell++) {
                    imageUrls[iCell].imageFormat = 'JPEG';
                }

                defer.resolve(imageUrls);
            },
            function (status) {
                let imageUrls = [{
                    cell: {page: cacheCellRequests[0].page, record: cacheCellRequests[0].record},
                    storageId: generateMissingImage()
                }];

                // if(!vm.previewErrorMsg) {
                //   vm.previewErrorMsg = status.engineError.smsError.message;
                // }
                // errorDialogOpen.openErrorDialog(status.engineError);
                defer.resolve(imageUrls);
            }
        );
        return defer.promise;
    }

    function generateMissingImage() {
        return missingImageWithText + "?" + new Date().getTime();
    }

    let getNumOfSheets = function () {
        return vm.numOfSheets > 1 ? vm.numOfSheets : 1;
    };

    function compose($event) {
        let assetsLibraries = vm.selectedAssetLibs.map(curr => {
            return {
                assetsLibId: curr.assetsLibId,
                assetsLibUUID: curr.assetsLibUUID,
                name: curr.name,
                storageId: curr.storageId
            };
        });

      let numberOfRecords =
        (vm.dataManager.dbList && vm.dataManager.dbList.length > 0)
          ? vm.dataManager.dbList[0].parseData.data.length +
          (vm.dataManager.dbList[0].parseData.skipFirstRow && !vm.dataManager.skipFirstRow ? 1 : 0)
          : vm.dataManager.data.length;

      let minNumberOfRecords = numberOfRecords;
      let totalNumberOfRows = numberOfRecords;

      if (vm.repetitionColIndex !== null && vm.dataManager.repetitions > 0) {
        numberOfRecords = vm.dataManager.repetitions;
      } else if (vm.dataManager.numOfRecords > 0) {
        numberOfRecords = vm.dataManager.numOfRecords;
      }

      for (let db of vm.dataManager.dbList) {
        let dbNumberOfRecords = db.parseData.data.length;

        if (db.parseData.repetitions && db.parseData.repetitions.repetitionColIndex !== null && db.parseData.repetitions.repetitionCounter > 0) {
          dbNumberOfRecords = db.parseData.repetitions.repetitionCounter;
        } else if (vm.isDataFileLimitExceeded && db.parseData.numOfRecords > 0) {
          dbNumberOfRecords = db.parseData.numOfRecords;
        }

        db.parseData.totalNumberOfRecords = dbNumberOfRecords;
        db.parseData.totalNumberOfRows = dbNumberOfRecords;
        minNumberOfRecords =
          minNumberOfRecords > dbNumberOfRecords ? dbNumberOfRecords : minNumberOfRecords;
      }


        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: true,
            template: require('../compose_pdf_dialog/composePdfDialog.html'),
            controller: 'composePdfDialogController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {
                templateId: vm.template.templateId,
                isImpositionExist: vm.isImpositionExist,
                //overrideImpositionTemplateId: vm.impositionSelection.selectedImpositionTemplate.templateId,
                totalNumberOfRecords: numberOfRecords,
                minNumberOfRecords: minNumberOfRecords,
                totalNumberOfRows: totalNumberOfRows,
                skipFirstRecord: false,
                dataStorageId: vm.dataFileStorageId,
                dataStorageIds: vm.dataFileStorageIds,
                data: vm.dataManager.data,

                dbList: vm.dataManager.dbList,
                dataFileName: vm.csvFileLoader.fileName,
                templateName: vm.template.templateName,
                assetsLibraries: assetsLibraries,
                //numOfSheets: getNumOfSheets.bind(this),
                //numOfRecordsInSheet: vm.recordsInImposition / vm.sheetsInImposition,
                numOfPages: vm.template.numberOfPages,
                isDataFileLimitExceeded: vm.isDataFileLimitExceeded,
                delimiter: vm.dataManager.delimiter,
                repetitionColIndex: vm.repetitionColIndex,
                presets: vm.presets,
                selectedPreset: vm.selectedPreset,
                applyTemplatePresetSettings: vm.applyPresetSettings,
                isCustomDistributionEnabled: vm.impositionSelection.selectedImpositionTemplate.distributionAreaEnabled,
                fixedNumberOfRows: vm.template.fixedNumberOfRows > 1 ? vm.template.fixedNumberOfRows : null
            }
        });
    }

    function CsvFileLoader() {
        let reader = null;
        let readers = [];
        this.showProgress = false;
        this.fileName = null;
        this.toggelFileSelectSimulate = null;

        this.loadDataFromPageUrl = function () {
            let fileName = vm.dataFromStorageFile.dataFileName;
            let _this = this;
            let defer = $q.defer();

            templatesService.downloadDataToBlob(vm.dataFromStorageFile.dataFileStorageId, "text/plain", function (blob) {
                if (blob !== undefined && blob !== null) {
                    let files = [blob];
                    files[0].name = fileName;
                    vm.csvFileLoader.fileName = fileName;
                    _this.toggelFileSelectSimulate = fileName;
                    vm.csvFileLoader.onFileSelected(files);
                    defer.resolve();
                } else {
                    errorDialogOpen.openErrorDialog();
                    defer.reject();
                }
            });

            return defer.promise;
        };
        this.onFileSelected = function (files) {
            let functionName = 'detailedTemplateController.CsvFileLoader.onFileSelected';
            $log.info(angular.toJson({action: 'function called', functionName: functionName, files: files}));
            readers = [];
            workers = [];
            vm.dataManager.dbList = [];
            vm.dataFileStorageIds = [];
            vm.dbProgressDetails = [];
            for (let file of files) {
                if (file.size !== 0) {
                    vm.dbProgressDetails.push({
                        "fileName": file.name,
                        "storageAssetInfo": "",
                        "precent": (file.size > fileSizeEditLimit)? 0 : 100,
                        "isDataFileLimitExceeded": (file.size > fileSizeEditLimit),
                        "showProgress": true,
                        "isDataValid": null
                    });
                }
            }
            if(vm.dbProgressDetails.length > 0){
                this.showProgress = true;
                vm.dataManager.disableDataControls = true;
                vm.dataBeingUpdated = false;
                vm.dataManager.fileName = files[0].name;
                this.fileName = files[0].name;
                vm.isDataFileLimitExceeded = (files[0].size > fileSizeEditLimit);


                for (let file of files) {
                    if (file.size !== 0) {
                        this.onFileSelectedHandle(file);
                    }
                }
            }
        };

        this.onFileSelectedHandle = function (file) {

            if (file.size > fileSizeEditLimit) {
                //vm.isDataFileLimitExceeded = true;
                vm.dataBeingUpdated = true;
                templatesService.createEmptyFileEntryHelper(file).then(storageAssetInfo => {
                    vm.dbProgressDetails.filter(x => x.fileName === file.name)[0].storageAssetInfo = storageAssetInfo.assetId;
                    templatesService.uploadFile(file, uploadProgressCallback, storageAssetInfo).then(storageId => {
                        let storageDetails = {"storageId": storageId, "fileName": file.name};
                        vm.dataFileStorageIds.push(storageDetails);
                        vm.dataFileStorageId = storageId;
                        if(vm.dbProgressDetails.every(x => x.precent > 90)){
                            this.showProgress = false;
                            vm.dataManager.dbList = vm.dataManager.dbList.filter(db => vm.dbProgressDetails.some(p => p.fileName === db.fileName && p.isDataValid));
                            if(vm.dataManager.dbList.length > 0){
                                let dbTpUpdateCurrent = vm.dataManager.dbList[0];
                                onDbSelected(dbTpUpdateCurrent);
                                vm.dataBeingUpdated = false;
                            }
                        }
                    }, error => console.log(error));
                }, error => console.log(error));

            } else {
                vm.dbProgressDetails.filter(x => x.fileName === file.name)[0].isDataFileLimitExceeded = false;
                vm.isDataFileLimitExceeded = false;
                vm.dataFileStorageId = null;
            }
            reader = new FileReader();
            reader.fileName = file.name;

            let index = readers.push(reader) - 1;
            readers[index].onload = this.onDataFileRead;
            readers[index].readAsText(file);
        };

        this.onDataFileRead = async function (e) {

            let text = e.currentTarget.result;
            const fileName = e.currentTarget.fileName;

            vm.dataBeingUpdated = true;

            const parsedData = await parseDataFromFile(text);
            vm.dbProgressDetails.filter(x => x.fileName === fileName)[0].isDataValid = (parsedData.isDataValid !== false);

            ////let firstRowIndex = text.indexOf('\n');
            ////parsedData.firstRow = (firstRowIndex !== -1)? text.substring(0,firstRowIndex) : parsedData.firstRow;
            ////parsedData.shouldSkipFirstRow = true;

            vm.dataManager.updateDataFromText(parsedData, fileName);
            setRepetitionsInfoText(parsedData.repetitions, parsedData.data);
            handlePresetSkipFirstRow(vm.selectedPreset);

            if (vm.isDataFileLimitExceeded === false) {
                vm.csvFileLoader.showProgress = false;
                vm.dataBeingUpdated = false;
            }
        };
    }

    function parseDataFromFile(data) {
        return new Promise((resolve, reject) => {
            let guessingFormat = null;
            if (vm.csvFileLoader !== undefined && vm.csvFileLoader !== null && vm.csvFileLoader.fileName !== undefined && vm.csvFileLoader.fileName !== null) {
                let fileExtension = vm.csvFileLoader.fileName.split('.').pop();
                if (fileExtension !== vm.csvFileLoader.fileName) {
                    if (fileExtension === 'txt' || fileExtension === 'TXT') {
                        guessingFormat = 'TXT';
                    } else if (fileExtension === 'csv' || fileExtension === 'CSV') {
                        guessingFormat = 'CSV';
                    }
                }
            }

            parseDataFromText(data, guessingFormat).then(result => {
                resolve(result);
            });
        });
    }

    function parseDataFromText(data, format) {
        return new Promise(resolve => {
            let result = {};

            let previewLimit = vm.isDataFileLimitExceeded ? recordsLimit : null;
            parseDbTextAsync(data, format, previewLimit).then(parsedModel => {
                if (parsedModel.error === undefined) {
                    result.isDataValid = true;
                    result.data = parsedModel.data;
                  result.firstRow = parsedModel.skipFirstRow
                    ? parsedModel.headers
                    : parsedModel.data[0];
                    result.numOfRecords = parsedModel.numOfRecords;
                    result.repetitions = parsedModel.repetitions;
                    result.delimiter = parsedModel.delimiter;
                    result.shouldSkipFirstRow = parsedModel.skipFirstRow;
                    result.userMessage = parsedModel.error;
                    vm.repetitionColIndex = parsedModel.repetitions.repetitionColIndex;
                    vm.headers = parsedModel.headers;

                } else {
                    result.isDataValid = false;
                }
                resolve(result);
            });
        });
    }

    vm.onRecordSelectionChange = function () {
        vm.dataManager.onRecordChange();
        if (vm.repetitionColIndex !== null) {
            vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repeat_by_column_enabled', [vm.dataManager.data[vm.dataManager.selectedRecord - 1][vm.repetitionColIndex]]);
        }
    };

    function parseDbTextAsync(data, guessingFormat, previewLimit) {
        let promise = new Promise((resolve, reject) => {
            let workerParams = {
                headers: vm.headers,
                data: data,
                guessingFormat: guessingFormat,
                isPredefined: vm.template.predefined,
                previewLimit: previewLimit,
                repetitionColumn: vm.template.repetitionColumn
            };

            // if (typeof(worker) === "undefined") {
            //   worker = new repetitionCounterWorker();
            // }
            let newWorker = new repetitionCounterWorker();
            newWorker.postMessage(workerParams);


            workers.push(newWorker);
            let index = workers.push(newWorker) - 1;
            workers[index].addEventListener("message", function (event) {
                resolve(event.data);
            });
        });
        //   worker.addEventListener("message", function(event) {
        //     resolve(event.data);
        //   });
        // });

        return promise;
    }

    function applyChanges($event) {
        if (vm.editingForm.$dirty) {
            let templateForEdit = getEmptyTemplate();
            templateForEdit.templateId = vm.template.templateId;

            if (vm.editingForm.templateName.$dirty) {
                templateForEdit.templateName = vm.template.templateName;
            }

            if (vm.editingForm.preset.$dirty) {
                templateForEdit.presetId = vm.template.presetId;
            }

            if (vm.editingForm.engineMode && vm.editingForm.engineMode.$dirty && vm.template.engineMode !== vm.originalTemplateInfo.engineMode) {
                templateForEdit.engineMode = vm.template.engineMode;
                vm.dataManager.resetPreview();
                if (templateForEdit.engineMode !== vm.selectedPreset.preferredMode) {
                    vm.template.customSettings = true;
                }
            }

            if (vm.editingForm.templateDescription.$dirty) {
                templateForEdit.templateDescription = vm.template.templateDescription;
            }

            if (vm.editingForm.impositionTemplate.$dirty) {
                if (vm.impositionSelection.selectedImpositionTemplate.isNoImpositionEntry) {
                    templateForEdit.overrideImpositionId = -1;
                    vm.numOfSheets = 0;
                } else {
                    if (vm.impositionSelection.selectedImpositionTemplate.templateId === null) { // unnamed template
                        templateForEdit.overrideImpositionId = -2;
                        vm.numOfSheets = 0;
                    } else {
                        templateForEdit.overrideImpositionId = vm.impositionSelection.selectedImpositionTemplate.templateId;
                    }
                }

                if (templateForEdit.overrideImpositionId &&
                    (vm.selectedPreset.impositionId > 0 && templateForEdit.overrideImpositionId !== vm.selectedPreset.impositionId) || //custom imposition
                    (vm.selectedPreset.impositionId === -1 && vm.selectedPreset.applyImposition && templateForEdit.overrideImpositionId !== vm.template.impositionDefaultId) || // embeded imposition
                    (vm.selectedPreset.impositionId === -1 && vm.selectedPreset.applyImposition === false && templateForEdit.overrideImpositionId !== -1)) { // no imposition
                    vm.template.customSettings = true;
                }
            }

            if (vm.template.customSettings === false) {
                templateForEdit.customSettings = false;
            } else {
                vm.restorePresetTooltip = $translate.instant('imposer.composer-main.template_preset_restore_preset_tooltip');
            }

            $mdDialog.show({
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false,
                escapeToClose: false,
                template: require('../wait-for-apply-dialog/waitForApplyDialog.html'),
                controller: 'waitForApplyDialogController',
                bindToController: true,
                controllerAs: 'vm',
                locals: {
                    updatedValues: templateForEdit
                }
            }).then(function (updatedTemplate) {
                analyticsFactory.eventTrack(analyticsFactory.actions.applyChanges, analyticsFactory.categories.composer, analyticsFactory.labels.success, null);
                templatesService.addDisplayStatusToTemplate(updatedTemplate);
                //vm.previewWithImposition = false;
                vm.originalPresetInfo = angular.copy(vm.selectedPreset);

                if (vm.template.impositionDefaultExist || vm.template.overrideImpositionId !== -1) {
                    if (vm.impositionSelection.selectedImpositionTemplate.isNoImpositionEntry) {
                        vm.recordsInImposition = 1;
                        vm.sheetsInImposition = 1;
                        //updateJobProperties();
                    } else if (vm.template.overrideImpositionId !== updatedTemplate.overrideImpositionId) {
                        //updateSheetCount();
                    }
                } else {
                    vm.numOfSheets = getDataLength();
                }

                vm.template = updatedTemplate;

                vm.impositionSelection = new impositionTemplatesService.ImpositionSelection(isCustomDistributionRequired());
                vm.impositionSelection.setDefaultImpositionTemplate(vm.template.impositionDefaultExist, vm.template.impositionDefaultId,
                    vm.template.overrideImpositionId, vm.template.isDuplexImpJlyt);

                handleImpositionPreviewState();

                saveTemplateRestore(updatedTemplate);
                vm.impositionSelection.saveImpositionSelection();

            }, function () {
                analyticsFactory.eventTrack(analyticsFactory.actions.applyChanges, analyticsFactory.categories.composer, analyticsFactory.labels.failure, null);
                restoreTemplateInfo();
            });
            vm.editingForm.$setPristine();
        }
    }

    function saveTemplateRestore(template) {
        vm.originalTemplateInfo = angular.copy(template);
    }

    function restoreTemplateInfo() {
        vm.template = angular.copy(vm.originalTemplateInfo);
        vm.templateId = vm.template.templateId;
        vm.impositionSelection.restoreImpositionSelection();
    }

    function getEmptyTemplate() {
        return {
            templateId: null,
            templateDescription: null,
            templateName: null,
            templateStorageId: null,
            numberOfPages: null,
            thumbnailStorageId: null,
            defaultDbStorageId: null,
            defaultDbType: null,
            tags: null,
            templateCreationStatus: null,
            impositionDefaultExist: null,
            impositionDefaultId: null,
            overrideImpositionId: null,
            currentImpositionNumberOfSheets: null
        };
    }

    function openImpositionEdit($event) {
        if (!vm.impositionSelection.selectedImpositionTemplate.templateId) {
            return;
        }

        let stateArgs = {
            'composerTemplateId': vm.template.templateId,
            'templateId': vm.impositionSelection.selectedImpositionTemplate.templateId,
            trimBox:
                {
                    width: vm.template.trimBoxWidth,
                    height: vm.template.trimBoxHeight
                },
            mediaBox:
                {
                    width: vm.template.mediaBoxWidth,
                    height: vm.template.mediaBoxHeight
                },
            hpdFileName: vm.template.templateName + ".hpd"
        };

        let dataViewState = null;
        if ($state.current.name === 'templates.templatedetailswithdata') {
            dataViewState = 'templates.templatedetailswithdata.imposition';
            stateArgs.dataFileStorageId = vm.dataFromStorageFile.dataFileStorageId;
            stateArgs.dataFileName = vm.dataFromStorageFile.dataFileName;
        } else {
            dataViewState = 'templates.templatedetails.imposition';
        }

        switchToState(dataViewState, stateArgs);
    }

    function openCounterWizard($event) {
        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: false,
            template: require('./counter-wizard/counter-wizard.html'),
            controller: 'CounterWizardController',
            bindToController: true,
            controllerAs: 'vm',
        }).then(function (counterDB) {
            vm.dataUploadReset = true;
            parseDataFromText(counterDB.data, 'TXT', "counter").then(parsedData => {
                vm.dataManager.resetDbList();
                vm.dataManager.updateDataFromText(parsedData, "counter");
                setRepetitionsInfoText(parsedData.repetitions);
            });
        });
    }
    function onDbSelected (newDb){
        let parseData = newDb.parseData;
        let newFileName = newDb.fileName;
        if(newFileName !== vm.dataManager.fileName){
            vm.dataManager.fileName = newDb.fileName;
            vm.dataManager.firstRecordBackup = parseData.firstRow;
            vm.csvFileLoader.fileName =  newDb.fileName;
            vm.isDataFileLimitExceeded = vm.dbProgressDetails.filter(x => x.fileName === newDb.fileName)[0].isDataFileLimitExceeded;
            vm.dataManager.updateDataFromText(parseData, newFileName);
        }
    }
    function openDbListDialog($event) {
        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: false,
            template: require('./db-list/db-list.html'),
            controller: 'DbListController',
            bindToController: true,
            controllerAs: 'vm',
            locals: {dbList: vm.dataManager.dbList},//, currentDb: vm.currentDb

            onDbSelected: function (newDb) {
                onDbSelected(newDb);
                // let parseData = newDb.parseData;
                // let newFileName = newDb.fileName;
                // if(newFileName !== vm.dataManager.fileName){
                //     vm.dataManager.fileName = newDb.fileName;
                //     vm.csvFileLoader.fileName =  newDb.fileName;
                //     vm.isDataFileLimitExceeded = vm.dbProgressDetails.filter(x => x.fileName === newDb.fileName)[0].isDataFileLimitExceeded;
                //     vm.dataManager.updateDataFromText(parseData, newFileName);
                // }
            },
            removeDb: function (dbToRemove) {
                let isCurrentDb = (vm.dataManager.fileName === dbToRemove.fileName)? true : false;
                 vm.dataManager.removeDb(dbToRemove.fileName);
                 if(isCurrentDb && vm.dataManager.dbList.length > 0){
                     let dbTpUpdateCurrent = vm.dataManager.dbList[0];
                     this.onDbSelected(dbTpUpdateCurrent);
                 }
            },
        })
            .then(function (counterDB) {
                vm.dataUploadReset = true;
                parseDataFromText(counterDB.data, 'TXT', "counter").then(parsedData => {
                    vm.dataManager.updateDataFromText(parsedData);
                    setRepetitionsInfoText(parsedData.repetitions);
                });
            });
    }

    function setRepetitionsInfoText(repetitions, currentDbFile) {
        if (repetitions && repetitions.isRepetitionValuesLegal === false) {
            vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repetition_values_not_valid');
        } else {
            let currentDb = (currentDbFile)? currentDbFile :  vm.dataManager.data;
            if (repetitions && repetitions.repetitionCounter && repetitions.repetitionCounter > 0) {
                vm.repetitionsInfoText = $translate.instant('imposer.composer-main.Total_of_rows', [currentDb.length, repetitions.repetitionCounter]);
                vm.repetitionsAdditionalInfoText = $translate.instant('imposer.composer-main.Repeat_by_column_enabled', [currentDb[vm.dataManager.selectedRecord - 1][vm.repetitionColIndex]]);
            } else if (vm.template.fixedNumberOfRows > 1) {
                vm.repetitionsInfoText = $translate.instant('imposer.composer-main.Total_of_rows', [currentDb.length, Math.ceil(currentDb.length / vm.template.fixedNumberOfRows)]);
                //TODO - add appropriate message to vm.repetitionsAdditionalInfoText
            }
        }
    }

    function onViewAllData() {
      let stateArgs = {
        'composerTemplateId': vm.template.templateId,
        'data':
          (vm.dataManager.dbList && vm.dataManager.dbList.length > 0)
            ? vm.dataManager.dbList[0].parseData.data
            : vm.dataManager.data,
        'headers': vm.headers,
        'dataFileName': vm.csvFileLoader.fileName,
        'isDataFileLimitExceeded': vm.isDataFileLimitExceeded,
        'repetitionColumn': vm.template.repetitionColumn
      };
        let dataViewState = null;
        if ($state.current.name === 'templates.templatedetailswithdata') {
            dataViewState = 'templates.templatedetailswithdata.fulldataview';
            stateArgs.dataFileStorageId = vm.dataFromStorageFile.dataFileStorageId;
            stateArgs.dataFileName = vm.dataFromStorageFile.dataFileName;
        } else {
            dataViewState = 'templates.templatedetails.fulldataview';
        }
        switchToState(dataViewState, stateArgs);
    }

    function switchToState(stateName, stateArgs) {
        stateKeeperService.keepState('templates.templatedetails___vm.editingForm.templateName.$dirty', vm.editingForm.templateName.$dirty);
        stateKeeperService.keepState('templates.templatedetails___vm.editingForm.impositionTemplate.$dirty', vm.editingForm.impositionTemplate.$dirty);

        $state.transitionTo(stateName, stateArgs);
    }

    $scope.$watch('vm.editingForm', function (editingForm) {
        if (editingForm) {
            if (vm.isRestoreNeeded) {
                let templateNameDirty = stateKeeperService.getState('templates.templatedetails___vm.editingForm.templateName.$dirty');
                let impositionTemplateDirty = stateKeeperService.getState('templates.templatedetails___vm.editingForm.impositionTemplate.$dirty');

                if (templateNameDirty) {
                    vm.editingForm.templateName.$setDirty(true);
                }

                if (impositionTemplateDirty) {
                    vm.editingForm.impositionTemplate.$setDirty(true);
                }
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        if ($state.current.name === 'templates.templatedetails' || $state.current.name === 'templates.templatedetailswithdata') {
            vm.isRestoreNeeded = false;
            vm.hideCurrentView = false;
        } else {
            vm.isRestoreNeeded = true;
            vm.hideCurrentView = true;
        }

        /*if(((from.name === 'templates.templatedetails') && ((to.name === 'templates.templatedetails.fulldataview') ||
            (to.name === 'templates.templatedetails.imposition') || (to.name === 'templates.templatedetails.imposedpreview') ||
            (to.name === 'templates.templatedetails.imposition') || (to.name === 'templates.templatedetails.pagepreview') || (to.name === 'templates.templatedetails.imposition.zoomin'))) ||
            ((from.name === 'templates.templatedetailswithdata') &&
            ((to.name === 'templates.templatedetailswithdata.fulldataview') || (to.name === 'templates.templatedetailswithdata.imposition')))){
            vm.isRestoreNeeded = true;
            vm.hideCurrentView = true;
        }else{
            vm.isRestoreNeeded = false;
            vm.hideCurrentView = false;
        }*/


        if (((from.name === 'templates.templatedetails.imposition') && (to.name === 'templates.templatedetails')) ||
            (from.name === 'templates.templatedetailswithdata.imposition') && (to.name === 'templates.templatedetailswithdata') ||
            (from.name === 'templates.templatedetails.impositionpreview') && (to.name === 'templates.templatedetails')) {
            //vm.withImpositionPreviewManager = new WithImpositionPreviewManager();
            //vm.withImpositionPreviewManager.activate();

            // update template name as it may be changed by the editing.
            vm.impositionSelection.reloadSelectedTemplate();
        }
    });

    $scope.$watch('vm.headers', function (headers) {
        calculateDbElementHeight();
    });

    angular.element($window).bind('resize', function () {
        calculateDbElementHeight();
        $scope.$digest();
    });

    function calculateDbElementHeight() {
        if (vm.headers) {
            if ($window.innerWidth >= 960) {
                vm.dbHeight = 54 * (vm.headers.length + 1); // + 1 is needed due to Safari Shit
            } else {
                vm.dbHeight = 200;
            }
        } else {
            vm.dbHeight = 0;
        }


        vm.dbHeight += 'px !important';
    }

    function calcPercentageToAllDb() {
        let sumOfAllPrecents = 0;
        for (let dbDetails of vm.dbProgressDetails) {
            sumOfAllPrecents += dbDetails.precent;
        }
        return (sumOfAllPrecents / vm.dbProgressDetails.length);
    }

    function uploadProgressCallback(uploadReportPercentage, assetId) {
        if (uploadReportPercentage) {
            vm.dbProgressDetails.filter(x => x.storageAssetInfo  === assetId)[0].precent = uploadReportPercentage;
            let percentageToAllDb = calcPercentageToAllDb();
            vm.uploadProgress = percentageToAllDb;
            vm.knownProgress = true;
            if (percentageToAllDb === 100) {
                vm.knownProgress = false;
                //this.showProgress = false;
            }
            $scope.$apply();
        }
    }

    function onPresetUnlink(templateIds) {
        if (templateIds && Array.isArray(templateIds)) {
            for (let templateId of templateIds) {
                if (templateId === vm.templateId) {
                    vm.selectedPreset = vm.presets.filter(preset => preset.default === true)[0];
                    vm.template.presetId = vm.selectedPreset.id;
                    vm.template.presetChanged = true;
                    vm.restorePresetTooltip = $translate.instant('imposer.composer-main.template_preset_unlink_tooltip');
                    break;
                }
            }
        }
    }

    function onImpositionUnlink(templateIds) {
        if (templateIds && Array.isArray(templateIds)) {
            for (let templateId of templateIds) {
                if (templateId === vm.templateId) {
                    //let impositionId = vm.impositionSelection.selectedImpositionTemplate.templateId;
                    //vm.impositionSelection.removeFromSelection(impositionId);
                    vm.impositionSelection.applyDefaultImposition();
                }
            }
        }
    }

    function onPresetEntryAdded(newPreset) {
        if (newPreset) {
            if (newPreset.sameNameIndex > 0) {
                newPreset.name = newPreset.name + '-' + newPreset.sameNameIndex;
            }
            vm.presets.push(newPreset);
        }
    }

    function onPresetEntryChanged(updatedPreset) {
        if (updatedPreset) {
            vm.presets = vm.presets.map(preset => {
                if (preset.id === updatedPreset.id) {
                    if (updatedPreset.sameNameIndex > 0) {
                        updatedPreset.name = updatedPreset.name + '-' + updatedPreset.sameNameIndex;
                    }
                    return updatedPreset;
                } else {
                    return preset;
                }
            });
            if (vm.selectedPreset.id === updatedPreset.id) {
                vm.applyPresetSettings(updatedPreset, false);
            }
        }
    }

    function isCustomDistributionRequired() {
        return vm.template.engineMode === 'Fast' && vm.template.repetitionColumn === null && vm.template.numberOfPages === 1;
    }

    vm.onEngineModeChange = function () {
        if (vm.template.engineMode === 'Rich') {
            vm.impositionSelection.removeCustomDistributionImpositions();
            if (vm.impositionSelection && vm.impositionSelection.selectedImpositionTemplate.distributionAreaEnabled) {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    escapeToClose: true,
                    template: require('@printos/imposer-ui/src/components/common/confirm-dialog/confirmDialog.html'),
                    controller: 'confirmDialogController',
                    bindToController: true,
                    controllerAs: 'vm',
                    locals: {
                        title: 'imposer.composer-main.Composer_Status_Warning',
                        confirmMessage: $translate.instant('imposer.composer-main.custom_distribution_not_supported_rich'),
                    }
                }).then(function () {
                    vm.impositionSelection.setDefaultImpositionTemplate(vm.template.impositionDefaultExist, vm.template.impositionDefaultId, null, vm.template.isDuplexImpJlyt, true);
                    vm.editingForm.impositionTemplate.$setDirty(true);
                }, error => {
                    vm.template.engineMode = 'Fast';
                    vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired());
                });
            }
        } else {
            vm.impositionSelection.restoreCustomDistributionImpositions(isCustomDistributionRequired());
        }
    };

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
        vm.source = from;
        if ($state.current.name === 'templates.templatedetails' && from.name === 'templates.templatedetails.imposition') {
            /*if (vm.numOfSheets !== 0) {
              updateSheetCount();
            }*/
        }
    });

    $scope.$on('$destroy', function () {
        rnPusher.unbind(vm.channelName, "HPD_ENTRY_PRESET_UNLINK", onPresetUnlink);
        rnPusher.unbind(vm.channelName, "HPD_ENTRY_IMPOSITION_UNLINK", onImpositionUnlink);
        rnPusher.unbind(vm.channelName, "PRESET_LIST_ENTRY_ADDED", onPresetEntryAdded);
        rnPusher.unbind(vm.channelName, "PRESET_LIST_ENTRY_CHANGED", onPresetEntryChanged);
    });
}
